import styled from 'styled-components';
import { s } from './VIPReport.style';
import { IReportData } from '../../../service/quant/Quant';

const ReturnAnalysis = ({
  data,
}: {
  data?: {
    simulation1?: IReportData['simulation1'];
    simulation2?: IReportData['simulation2'];
    simulation3?: IReportData['simulation3'];
    simulation4?: IReportData['simulation4'];
  };
}) => {
  const { simulation1, simulation2, simulation3, simulation4 } = data || {};

  return (
    <s.Div>
      <s.Title>💸수익률 시뮬레이션</s.Title>
      <StepDiv>
        <Step>
          <Num>1</Num>
          <div>예상 선투입비용</div>
        </Step>
        <s.Table>
          <s.TableHeader>
            <s.Header>항목</s.Header>
            <s.Header>금액</s.Header>
          </s.TableHeader>
          <s.Row>
            <RowLeft>입찰가</RowLeft>
            <RowRight>
              {simulation1?.bidPrc ? simulation1?.bidPrc.toLocaleString() : '-'}
              원
            </RowRight>
          </s.Row>
          <s.Row>
            <RowLeft>
              취득세(
              {simulation1?.acquisitionTaxRate
                ? simulation1?.acquisitionTaxRate
                : '-'}
              %)
            </RowLeft>
            <RowRight>
              {simulation1?.acquisitionTax
                ? simulation1?.acquisitionTax.toLocaleString()
                : '-'}
              원
            </RowRight>
          </s.Row>
          <s.Row>
            <RowLeft>법무사비</RowLeft>
            <RowRight>
              {simulation1?.legalFee
                ? simulation1?.legalFee.toLocaleString()
                : '-'}
              원
            </RowRight>
          </s.Row>
          <s.Row>
            <RowLeft>이사명도비</RowLeft>
            <RowRight>
              {simulation1?.movingCost || simulation1?.movingCost === 0
                ? simulation1?.movingCost.toLocaleString()
                : '-'}
              원
            </RowRight>
          </s.Row>
          <s.Row>
            <RowLeft>인테리어 수리비</RowLeft>
            <RowRight>
              {simulation1?.repairCost || simulation1?.repairCost === 0
                ? simulation1?.repairCost.toLocaleString()
                : '-'}
              원
            </RowRight>
          </s.Row>
          <s.Row style={{ backgroundColor: '#F0F8FF' }}>
            <RowLeft>총 선투입비</RowLeft>
            <RowRight style={{ color: '#008aff' }}>
              {simulation1?.upfrontCost
                ? simulation1?.upfrontCost.toLocaleString()
                : '-'}
              원
            </RowRight>
          </s.Row>
        </s.Table>
      </StepDiv>
      <StepDiv>
        <Step>
          <Num>2</Num>
          <div>경락잔금대출 회수 예상</div>
        </Step>
        <ColumnBox>
          <ColumnTitle>예상 대출금</ColumnTitle>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <ColumnNum>
              {simulation2?.loanCost
                ? simulation2?.loanCost.toLocaleString()
                : '-'}
              원
            </ColumnNum>
            <ColumnBottom>입찰가의 80%</ColumnBottom>
          </div>
        </ColumnBox>
        <ColumnBox>
          <ColumnTitle>실투자금 = 선투입비 - 대출금</ColumnTitle>
          <ColumnNum>
            {simulation2?.investmentCost
              ? simulation2?.investmentCost.toLocaleString()
              : '-'}
            원
          </ColumnNum>
        </ColumnBox>
        <s.BottomDescription>
          <span>
            본 계산에서는 경락잔금대출 비율을{' '}
            <span style={{ color: '#008AFF' }}>50% 기준으로 가정</span>
            하였습니다.
            <br />
            단, 실제 대출 가능 금액은{' '}
            <span style={{ color: '#008AFF' }}>
              개인의 신용 상태, 소득 요건, 부동산의 용도 및 감정가
            </span>
            에 따라 달라질 수 있으며, 금융기관의 심사 결과에 따라 변동될 수
            있습니다.
            <br />
            (면책조건으로 제공됨)
          </span>
        </s.BottomDescription>
      </StepDiv>
      <StepDiv>
        <Step>
          <Num>3</Num>
          <div>수익 계산</div>
        </Step>
        <ColumnBox style={{ gap: '24px' }}>
          <div>
            <ColumnTitle>매매차익</ColumnTitle>
            <div>
              <ColumnNum style={{ color: '#222222' }}>
                {simulation3?.saleProfit
                  ? simulation3?.saleProfit.toLocaleString()
                  : '-'}
                원
              </ColumnNum>
              <ColumnBottom>
                {simulation3?.salePrc
                  ? simulation3?.salePrc.toLocaleString()
                  : '-'}
                원 -{' '}
                {simulation3?.bidPrc
                  ? simulation3?.bidPrc.toLocaleString()
                  : '-'}
                원
              </ColumnBottom>
            </div>
          </div>
        </ColumnBox>
        <ColumnBox style={{ padding: 0, gap: 0 }}>
          <div style={{ padding: '16px 0 18px' }}>
            <ColumnTitle style={{ fontWeight: 700, margin: 0 }}>
              예상 이자비용
            </ColumnTitle>
          </div>
          <div
            style={{ width: '100%', height: '1px', background: '#E5E8EA' }}
          />
          <div
            style={{
              padding: '14px 24px',
              display: 'flex',
              flexDirection: 'column',
              gap: '16px',
              width: '100%',
            }}
          >
            <SubBox>
              <SubBoxInner>
                <SubBoxTitle>
                  대출이자<span>5%</span>
                </SubBoxTitle>
                <SubBoxContent>
                  {simulation3?.interest
                    ? simulation3?.interest.toLocaleString()
                    : '-'}
                  원
                </SubBoxContent>
              </SubBoxInner>
              <SubBoxInner>
                <SubBoxTitle>대출 중도 상환수수료</SubBoxTitle>
                <SubBoxContent>
                  {simulation3?.prepaymentFee
                    ? simulation3?.prepaymentFee.toLocaleString()
                    : '-'}
                  원
                </SubBoxContent>
              </SubBoxInner>
            </SubBox>
            <SubBox2>
              <SubBoxInner>
                <SubBoxTitle>이자비용 합계</SubBoxTitle>
                <SubBoxContent style={{ color: '#008AFF' }}>
                  {simulation3?.totalInterest
                    ? simulation3?.totalInterest.toLocaleString()
                    : '-'}{' '}
                  원
                </SubBoxContent>
              </SubBoxInner>
            </SubBox2>
          </div>
        </ColumnBox>
        <ColumnBox style={{ padding: 0, gap: 0 }}>
          <div style={{ padding: '16px 0' }}>
            <ColumnTitle style={{ fontWeight: 700 }}>예상 과세표준</ColumnTitle>
          </div>
          <div
            style={{ width: '100%', height: '1px', background: '#E5E8EA' }}
          />
          <div
            style={{
              padding: '17px 24px 16px',
              display: 'flex',
              flexDirection: 'column',
              gap: '24px',
              width: '100%',
            }}
          >
            <SubBox>
              <SubBoxInner>
                <SubBoxTitle>매각차익 - 부대비용 (필요경비)</SubBoxTitle>
                <SubBoxContent>
                  {simulation3?.stdPrc
                    ? simulation3?.stdPrc.toLocaleString()
                    : '-'}
                  원
                </SubBoxContent>
              </SubBoxInner>
              <SubBoxInner>
                <SubBoxTitle>
                  국세 (종합소득세)
                  <span>
                    {simulation3?.nationalTaxRate
                      ? simulation3?.nationalTaxRate
                      : '-'}
                    %
                  </span>
                </SubBoxTitle>
                <SubBoxContent>
                  {simulation3?.nationalTax
                    ? simulation3?.nationalTax.toLocaleString()
                    : '-'}
                  원
                </SubBoxContent>
              </SubBoxInner>
              <SubBoxInner>
                <SubBoxTitle>
                  지방세
                  <span>
                    {simulation3?.localTaxRate
                      ? simulation3?.localTaxRate
                      : '-'}
                    %
                  </span>
                </SubBoxTitle>
                <SubBoxContent>
                  {simulation3?.localTax
                    ? simulation3?.localTax.toLocaleString()
                    : '-'}
                  원
                </SubBoxContent>
              </SubBoxInner>
            </SubBox>
            <SubBox2>
              <SubBoxInner>
                <SubBoxTitle>총 세액부담</SubBoxTitle>
                <SubBoxContent style={{ color: '#008AFF' }}>
                  {simulation3?.totalTax
                    ? simulation3?.totalTax.toLocaleString()
                    : '-'}{' '}
                  원
                </SubBoxContent>
              </SubBoxInner>
            </SubBox2>
          </div>
        </ColumnBox>
        <ColumnBox style={{ gap: '24px' }}>
          <div>
            <ColumnTitle>예상 중개수수료</ColumnTitle>
            <div>
              <ColumnNum style={{ color: '#222222' }}>
                약{' '}
                {simulation3?.commission
                  ? simulation3?.commission.toLocaleString()
                  : '-'}
                원
              </ColumnNum>
              <ColumnBottom>
                {simulation3?.commissionRate
                  ? simulation3?.commissionRate
                  : '-'}
                %
              </ColumnBottom>
            </div>
          </div>
          <div>
            <ColumnTitle>예상 법무사비</ColumnTitle>
            <div>
              <ColumnNum style={{ color: '#222222' }}>
                약{' '}
                {simulation3?.legalFee
                  ? simulation3?.legalFee.toLocaleString()
                  : '-'}
                원
              </ColumnNum>
            </div>
          </div>
        </ColumnBox>
        <ColumnBox style={{ gap: '24px' }}>
          <div>
            <ColumnTitle
              style={{ display: 'flex', flexDirection: 'row', gap: '4px' }}
            >
              예상 세후이익<ProfitTag>순수익</ProfitTag>
            </ColumnTitle>
            <div>
              <ColumnNum>
                {simulation3?.afterTaxProfit
                  ? simulation3?.afterTaxProfit.toLocaleString()
                  : '-'}
                원
              </ColumnNum>
              <ColumnBottom>
                {simulation3?.saleProfit
                  ? simulation3?.saleProfit.toLocaleString()
                  : '-'}
                원 - 이자 - 세금 등
              </ColumnBottom>
            </div>
          </div>
        </ColumnBox>
        <s.BottomDescription style={{ padding: '16px 24px' }}>
          <TaxNav>
            <TaxNabSub>
              <div
                style={{
                  display: 'block',
                  fontSize: '14px',
                  fontWeight: '700',
                }}
              >
                세금 안내
              </div>
              <div style={{ display: 'block' }}>
                부동산 매매차익에 대한 과세는 거래 형태와 횟수에 따라
                달라집니다.
              </div>
            </TaxNabSub>
            <TaxNabSub>
              <div style={{ display: 'block' }}>
                <span style={{ fontWeight: '700' }}>・사업소득 과세</span> :
                매매사업자 기준 반복적·계획적 매매 시 종합소득세(사업소득) 및
                지방소득세 부과
              </div>
              <div style={{ display: 'block' }}>
                <span style={{ fontWeight: '700' }}>・양도소득세 과세</span> :
                1회성 매도 시 양도소득세 부과(보유 기간, 보유 주택 수 등 조건에
                따라 세율·공제 달라짐)
              </div>
            </TaxNabSub>
            <div style={{ display: 'block' }}>
              정확한 세액 산출과 최적의 절세 전략을 위해{' '}
              <span style={{ color: '#008AFF' }}>
                세무사·회계사 등 전문가 상담
              </span>
              을 권장드립니다. (면책조건으로 제공됨)
            </div>
          </TaxNav>
        </s.BottomDescription>
      </StepDiv>
      <StepDiv>
        <Step>
          <Num>4</Num>
          <div>수익률 지표</div>
        </Step>
        <RowBox>
          <div>
            <ColumnTitle>ROI (총 투자 대비 수익률)</ColumnTitle>
            <div>
              <ColumnNum>{simulation4?.roi || '-'}%</ColumnNum>
              <ColumnBottom>세후이익 ÷ 선투입비</ColumnBottom>
            </div>
          </div>
          <div>
            <ColumnTitle>ROE (자기자본 수익률)</ColumnTitle>
            <div>
              <ColumnNum>{simulation4?.roe || '-'}%</ColumnNum>
              <ColumnBottom>세후이익 ÷ 실투자금</ColumnBottom>
            </div>
          </div>
        </RowBox>
      </StepDiv>

      <s.BottomDescription>
        <div>
          ROI는 전체 투자 대비 수익, ROE는 내 돈으로 얼마 벌었는지 보는
          지표예요.
          <br />
          레버리지를 얼마나 잘 쓰느냐에 따라 ROE는 훨씬 강력해질 수 있습니다.
        </div>
      </s.BottomDescription>
    </s.Div>
  );
};

export default ReturnAnalysis;

const RowLeft = styled.div`
  width: 160px;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: start;
  font-size: 14px;
  font-weight: 500;
  color: #222222;
`;

const RowRight = styled.div`
  width: calc(100% - 160px);
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: end;
  font-size: 14px;
  font-weight: 500;
  color: #222222;
`;

const StepDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Step = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 700;
  color: #222222;
`;

const Num = styled.div`
  padding: 10px;
  background-color: #e6f3ff;
  border-radius: 6px;
  width: 20px;
  height: 20px;
  font-size: 12px;
  font-weight: 700;
  color: #008aff;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ColumnBox = styled.div`
  width: 100%;
  padding: 24px 10px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  color: #222222;
  border-radius: 16px;
  border: 1px solid #e5e8ea;
`;

const ColumnTitle = styled.div`
  text-align: center;
  align-items: center;
  font-size: 13px;
  font-weight: 500;
  color: #222222;
  margin-bottom: 4px;
`;

const ColumnNum = styled.div`
  font-size: 18px;
  text-align: center;
  font-weight: 700;
  color: #008aff;
  line-height: 145%;
`;

const ColumnBottom = styled.div`
  font-size: 12px;
  text-align: center;
  font-weight: 500;
  color: rgba(55, 56, 60, 0.61);
`;

const RowBox = styled.div`
  width: 100%;
  padding: 24px 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 16px;
  font-weight: 500;
  color: #222222;
  border-radius: 16px;
  border: 1px solid #e5e8ea;

  & > div {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
  }
`;

const SubBox = styled.div`
  border-radius: 16px;
  gap: 24px;
  padding: 24px;
  background: #f7f8fc;
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
`;

const SubBoxTitle = styled.div`
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  font-size: 13px;
  line-height: 145%;
  letter-spacing: calc(13px * -0.02);
  color: #222222;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  span {
    color: #008aff;
  }
`;

const SubBoxContent = styled.div`
  font-family: Spoqa Han Sans Neo;
  font-weight: 700;
  font-size: 18px;
  line-height: 145%;
  letter-spacing: calc(18px * -0.02);
  color: #222222;
`;

const SubBoxInner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
`;

const SubBox2 = styled.div`
  border-radius: 16px;
  gap: 2px;
  padding: 24px;
  background: #f0f8ff;
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: center;
`;

const TaxNav = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  font-size: 13px;
  line-height: 145%;
  letter-spacing: calc(13px * -0.02);
`;

const TaxNabSub = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

const ProfitTag = styled.div`
  border-radius: 4px;
  padding-top: 2px;
  padding-right: 6px;
  padding-bottom: 2px;
  padding-left: 6px;
  background: #edf2f6;
  font-family: Spoqa Han Sans Neo;
  font-weight: 700;
  font-size: 11px;
  line-height: 145%;
  letter-spacing: calc(11px * -0.02);
  color: #00549b;
  width: fit-content;
`;
